export const downloadBase64Attachment = (
  base64Data,
  fileExtension,
  fileName
) => {
  let contentType;
  switch (fileExtension) {
    case 'pdf':
      contentType = 'application/pdf';
      break;
    case 'csv':
      contentType = 'text/csv';
      break;
    case 'txt':
      contentType = 'text/plain';
      break;
    case 'jpeg':
      contentType = 'image/jpeg';
      break;
    case 'png':
      contentType = 'image/png';
      break;
    default:
      contentType = 'application/pdf';
      break;
  }
  const data = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  const blob = new Blob([data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = fileName + '.' + fileExtension;
  downloadLink.click();
};

export const downloadCSVFile = (data) => {
  const blob = new Blob([data], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', 'Wyrażone zgody.csv');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
